import script from "./ActionOverflow.vue?vue&type=script&lang=ts"
export * from "./ActionOverflow.vue?vue&type=script&lang=ts"

import "./ActionOverflow.vue?vue&type=style&index=0&id=cfd18214&lang=css"

const __exports__ = script;

export default __exports__